// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2OJEf","choiceBoxes":"toolbarselects_choiceBoxes__1UTLy","simpleField":"toolbarselects_simpleField__2mY5I"};